import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-bottom: 1em;
  flex: 1;
  position: relative;
`

export const Label = styled.label`
  display: block;
  margin-bottom: .2em;
`

export const Select = styled.button`
  font: inherit;
  color: inherit;
  width: 100%;
  box-sizing: border-box;
  background: none;
  border: 2px solid currentColor;
  margin: 0;
  padding: .4em .6em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  --selected-color: ${props => props.theme.primary[props['data-color']]};
  text-align: left;

  span {
    display: flex;
    align-items: center;
    gap: .5em;
  }

  &[data-color] span::before {
    content: '';
    background: var(--selected-color);
    height: .8em;
    width: .8em;
    border-radius: 5em;
    display: block;
  }
`

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: ${props => props.theme.background};
  border: 2px solid currentColor;
  border-top: 0;
  padding: .5em 0;
  box-sizing: border-box;
  max-height: 10em;
  overflow-y: auto;
  z-index: 50;
`

export const Option = styled.button`
  font: inherit;
  color: inherit;
  margin: 0;
  padding: .4em .6em;
  width: 100%;
  display: block;
  box-sizing: border-box;
  border: 0;
  background: none;
  display: flex;
  align-items: center;
  gap: .5em;
  cursor: pointer;
  text-align: left;
  --option-color: ${props => props.theme.primary[props['data-color']]};

  &:hover, &[aria-selected=true] {
    background: ${props => props.theme.menuHighlight};
  }
  &[data-color]::before {
    content: '';
    background: var(--option-color);
    height: .8em;
    width: .8em;
    border-radius: 5em;
    display: block;
  }
`

export const Error = styled.span`
  display: block;
  font-size: .8em;
  color: ${props => props.theme.primary.red};
  margin-top: .2em;
`